import { render, staticRenderFns } from "./scenicSpot.vue?vue&type=template&id=13da6e4b&scoped=true"
import script from "./scenicSpot.vue?vue&type=script&lang=js"
export * from "./scenicSpot.vue?vue&type=script&lang=js"
import style0 from "./scenicSpot.vue?vue&type=style&index=0&id=13da6e4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13da6e4b",
  null
  
)

export default component.exports